import { ITruong } from "../../../model/respone/category/ITruong";
import { eTruongActionTypeIds } from "../../action-types/category/ITruongActionType";
import { baseAction } from "../IActionBase";

export const truongAction = {
    loadStart: () => baseAction(eTruongActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: ITruong[]) => baseAction(eTruongActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eTruongActionTypeIds.LOAD_ERROR, message),
}